import React, { useMemo } from 'react'
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, YAxisProps, CartesianGrid } from 'recharts'
import { Box } from '@mui/material'
import styles from './styles.module.css'
import { PILLAR_INFO } from 'constant'
import { calculateStringWidth, isDataKeyExistsInData } from 'utils'

export interface BarChartProps {
  data?: any[] | undefined
  isStackedBarChart: boolean
  xAxisTicks?: (string | number)[] | undefined
  yAxisTickRenderFunc?: YAxisProps['tick']
}

export default function BarChartRanking({ data, isStackedBarChart, xAxisTicks, yAxisTickRenderFunc }: BarChartProps) {
  const yAxisWidth = useMemo(() => {
    if (!data || data.length === 0) return 0
    const countryNameWidths = data.map((item) =>
      calculateStringWidth(item.countryName, 'normal 16px "CircularStdMedium", sans-serif'),
    )
    const maxWidth = Math.max(...countryNameWidths)

    return maxWidth - 15
  }, [data])

  return (
    <Box sx={{ width: '100%', pt: 3 }}>
      <ResponsiveContainer width='110%' height={(data ?? []).length * 34} className={styles.grid}>
        <BarChart layout='vertical' data={data} barSize={18}>
          <XAxis
            type='number'
            tickLine={false}
            axisLine={false}
            allowDataOverflow
            ticks={xAxisTicks}
            style={{ fontSize: '11px' }}
            fontFamily={'CircularStdBook'}
          />
          <YAxis
            dataKey='name'
            tickLine={false}
            axisLine={false}
            type='category'
            tick={yAxisTickRenderFunc}
            width={yAxisWidth}
            fontFamily={'CircularStdBook'}
            // padding={{ top: 30 }}
          />
          <CartesianGrid horizontal={false} vertical={true} />
          {!isStackedBarChart && <Bar dataKey='score' fill='rgb(36, 148, 153)' />}
          {isStackedBarChart && (
            <>
              {PILLAR_INFO.filter((el) => isDataKeyExistsInData(data, el)).map((pillar) => (
                <Bar
                  key={pillar.dataKey}
                  dataKey={pillar.dataKey}
                  fill={pillar.color}
                  stackId='a'
                  style={{ stroke: '#fff', strokeWidth: 1 }}
                />
              ))}
            </>
          )}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
